// extracted by mini-css-extract-plugin
module.exports = {"Backdrop":"Modal_Backdrop__1yrly","ModalOverlay":"Modal_ModalOverlay__2YMRl","slide-down":"Modal_slide-down__1XKzt"};